import { createClient } from "@supabase/supabase-js";

// Get Supabase credentials from environment variables
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Initialize Supabase client with options based on docs: https://supabase.com/docs
const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
  },
  realtime: {
    // Enable realtime subscriptions
    enabled: true,
  },
});

console.log("Supabase initialized with URL:", supabaseUrl);

// Export as named export to maintain compatibility with existing imports
export { supabase };
